<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  xlsxHandler: { type: Function, default: null },
});

const isDownloading = ref(false);
const isBusy = computed(() => props.loading || isDownloading.value);

const download = async () => {
  if (props.disabled || isBusy.value) return;

  if (!props.xlsxHandler) return;

  isDownloading.value = true;
  try {
    await props.xlsxHandler();
  } finally {
    isDownloading.value = false;
  }
};
</script>

<template>
  <woot-button
    icon="arrow-download"
    color-scheme="success"
    :disabled="disabled || isBusy"
    :is-loading="isBusy"
    :title="$t('REPORT.EXPORT_XLSX')"
    @click="download"
  >
    {{ $t('REPORT.EXPORT_XLSX') }}
  </woot-button>
</template>
